export const errorFocusMixins = {
    methods: {
        scrollToField(fieldElement) {
            if (fieldElement && fieldElement.$el) {
                const topOffset = fieldElement.$el.offsetTop;
                window.scrollTo({ top: topOffset, behavior: "smooth" });
                fieldElement.$el.focus();
            }
        },
        setFocusOnFirstErrorField() {
            this.$nextTick(() => {
                const firstErrorItem = this.$el.querySelector(".error-check");

                if (!firstErrorItem) {
                    return;
                }
                const inputField = firstErrorItem.querySelector("input");

                if (firstErrorItem) {
                    firstErrorItem.focus();
                    firstErrorItem.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                } else {
                    inputField.focus();
                    inputField.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            });
        },
    },
};
